'use client'

import * as React from 'react'
import { FreeTrialBanner } from '@web/components/free-trial-banner'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'
import { tw } from 'utils/classnames'
export function FreeTrialBannerCTA({ scrollElementId }: { scrollElementId: string }) {
  const targetRef = React.useRef<null | HTMLElement>(null)
  const [isAbove, setIsAbove] = React.useState(false)
  const { isLoading, data: userHasAllAccess } = useHasAllAccessQuery()

  React.useEffect(() => {
    const handleScroll = () => {
      if (!targetRef.current) {
        targetRef.current = document.querySelector(`#${scrollElementId}`)
        return
      }
      const rect = targetRef.current.getBoundingClientRect()
      const scrollTop = window.scrollY
      const windowHeight = window.innerHeight
      const docHeight = document.documentElement.scrollHeight

      const distanceFromBottom = docHeight - (scrollTop + windowHeight)

      setIsAbove(rect.bottom < 0 && distanceFromBottom > 300)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [userHasAllAccess, scrollElementId])

  if (isLoading || userHasAllAccess) {
    return null
  }

  return (
    <div
      className={tw(
        'duration-600 fixed bottom-0 left-0 right-0 z-10 flex w-full flex-col items-center justify-center overflow-hidden transition-all delay-500 ease-in-out',
        isAbove ? 'translate-y-0' : 'translate-y-full',
      )}
    >
      <FreeTrialBanner />
    </div>
  )
}
